module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-bg-bonus.a820ca31.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-bg-bonus.png
// module id = 2508
// module chunks = 11